import { ResponseError } from 'superagent';

export class RetryWithBackoff {
	private readonly maxAttempts: number;
	private readonly backOffMs: number;

	public constructor(maxAttempts: number, backOffMs: number) {
		this.maxAttempts = maxAttempts;
		this.backOffMs = backOffMs;
	}

	public async execute<T>(actionFn: () => Promise<T>): Promise<T> {
		return await this.doExecute(actionFn, 1);
	}

	private async doExecute<T>(
		actionFn: () => Promise<T>,
		attemptNo: number,
	): Promise<T> {
		try {
			return await actionFn();
		} catch (e) {
			if (attemptNo > this.maxAttempts) {
				throw e;
			}

			if (this.isNotRetriable(e)) {
				throw e;
			}

			await this.wait(attemptNo * this.backOffMs);
			return await this.doExecute(actionFn, attemptNo + 1);
		}
	}

	private isNotRetriable(e: any): boolean {
		if (this.isResponseError(e)) {
			return e.status !== undefined && (e.status < 500 || e.status >= 600);
		}

		return true;
	}

	private isResponseError(e: any): e is ResponseError {
		return 'status' in e;
	}

	private async wait(ms: number): Promise<void> {
		return await new Promise<void>((resolve) => setTimeout(resolve, ms));
	}
}
